import { gql } from '@apollo/client';

export const textCardBlockFragment = gql`
  fragment textCardBlock on TextCardBlock {
    __typename
    sys {
      ...sys
    }
    tagline
    heading
    bodyContent {
      ...textCardBlockRT
    }
    primaryCta {
      ...cta
    }
    textCardItemsCollection(limit: 4) {
      items {
        __typename
        sys {
          ...sys
        }
        heading
        description
        primaryCta {
          ...cta
        }
      }
    }
  }

  fragment textCardBlockRT on TextCardBlockBodyContent {
    json
    links {
      ...textCardBlockRTLinks
    }
  }

  fragment textCardBlockRTLinks on TextCardBlockBodyContentLinks {
    entries {
      hyperlink {
        ...hyperlink
        ...mediaAsset
      }
    }
  }
`;
